import config from '../../../config';
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../../../helpers';
import { appName } from '../appConfig'

const endpointPath=`${appName}/questionnaire`

export const questionnaireService = {
    getAll,
    getById,
    getDefault,
    getByName,
    create
};

function getAll(signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

function getById(id, signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${id}`, requestOptions, signal)
    .then(handleResponse)
}

function getDefault(id, signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/default`, requestOptions, signal)
    .then(handleResponse)
}

// Used by other apps (e.g. buddy) that need one specific, curated
// questionnaire by name rather than an id, which isn't guaranteed to match
// across deployments.
function getByName(name, signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/by_name?name=${encodeURIComponent(name)}`, requestOptions, signal)
    .then(handleResponse)
}

function create(payload, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), 'Content-Type': 'application/json' }, body: JSON.stringify(payload), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}`, requestOptions, signal)
    .then(handleResponse)
}